var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxGraduateOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4341_157589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4625 9.05072C21.0842 9.53111 21.0842 10.4693 20.4625 10.9497L12.7333 16.9221C12.3013 17.2558 11.6987 17.2558 11.2667 16.9221L3.53751 10.9497C2.91582 10.4693 2.91582 9.53111 3.53751 9.05072L11.266 3.0776C11.6981 2.74366 12.3019 2.74366 12.734 3.0776L20.4625 9.05072Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.8,
    y1: 13,
    x2: 5.8,
    y2: 20,
    stroke: "currentColor",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4341_157589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxGraduateOutline);
export default __webpack_public_path__ + "static/media/icon_24px_graduate_outline.f35907dcb364f18dfa4f3510ab510c0c.svg";
export { ForwardRef as ReactComponent };